import { useEffect, useState } from 'react'
import useHandleAPIError from '@/core/hooks/useHandleAPIError.ts'
import { useQuery } from '@tanstack/react-query'
import { appConfig } from '@/config/app.ts'
import usePagination from '@/core/hooks/usePagination.ts'
import { NotificationService } from '@/modules/utilities/notification/services/NotificationService.ts'

const useNotificationTable = () => {
  const [filters, setFilters] = useState<string>(
    `?limit=${appConfig.pagination.defaultValue}`
  )

  const { handleAPIError } = useHandleAPIError()

  const { data, isFetching, error } = useQuery({
    queryKey: ['listNotifications', filters],
    queryFn: () => NotificationService.getAll(filters)
  })

  useEffect(() => {
    if (error)
      handleAPIError(error, 'Error cargando el listado de notificaciones')
  }, [error, handleAPIError])

  const { pagination } = usePagination({
    currentFilters: filters,
    filterSetter: setFilters,
    offset: data ? data.pagination.start : 0,
    total: data ? data.pagination.total : 0
  })

  return {
    rows: data ? data.results : [],
    pagination,
    isLoadingTable: isFetching
  }
}

export default useNotificationTable
